import * as React from 'react'
import {Helmet} from 'react-helmet'

export default React.memo(
  ({
    author,
    canonicalUrl,
    datePublished,
    defaultTitle = "Danniel Hansel",
    description,
    image,
    isBlogPost,
    organization,
    title,
    url,
  }) => {
    const baseSchema = [
      {
        '@context': 'http://schema.org',
        '@type': 'WebSite',
        url,
        name: title,
        alternateName: defaultTitle,
      },
    ]

    const schema = isBlogPost
      ? [
          ...baseSchema,
          {
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                item: {
                  '@id': url,
                  name: title,
                  image,
                },
              },
              // {
              //   '@type': 'ListItem',
              //   position: 1,
              //   name: title,
              //   item: {
              //     '@id': url,
              //     name: title,
              //     image,
              //   },
              // },{
              //   '@type': 'ListItem',
              //   position: 2,
              //   name: title,
              //   item: {
              //     '@id': url,
              //     name: title,
              //     image,
              //   },
              // },
            ],
          },
          {
            '@context': 'http://schema.org',
            '@type': 'BlogPosting',
            mainEntityOfPage: {
              '@type': 'WebSite',
              '@id': canonicalUrl,
            },
            headline: title,
            description,
            image: {
              '@type': 'ImageObject',
              url: image,
            },
            url,
            name: title,
            alternateName: defaultTitle,
            author: {
              '@type': 'Person',
              name: author.name,
            },
            publisher: {
              '@type': 'Organization',
              name: organization.name,
              url: organization.url,
              logo: organization.logo,
            },
            datePublished,
          },
        ]
      : baseSchema

    return (
      <Helmet>
        {/* Schema.org tags */}
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
    )
  },
)